var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "badge",
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_badge)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fillPath",
    d: "M22.1112 6.1525C22.8331 2.46738 27.4765 1.22319 29.9443 4.05362C31.6199 5.97556 34.5537 6.12931 36.4211 4.39306C39.1712 1.83608 43.6591 3.55883 43.9919 7.29922C44.2179 9.83903 46.501 11.6878 49.0323 11.3808C52.7601 10.9287 55.3783 14.9603 53.449 18.1819C52.1389 20.3695 52.8993 23.2072 55.1276 24.4467C58.4093 26.272 58.1577 31.0726 54.7032 32.545C52.3575 33.5447 51.3047 36.2874 52.3789 38.5999C53.9609 42.0056 50.9356 45.7415 47.2755 44.9021C44.7901 44.3322 42.3263 45.9322 41.8361 48.4345C41.1141 52.1196 36.4708 53.3638 34.003 50.5334C32.3273 48.6115 29.3935 48.4577 27.5262 50.194C24.776 52.7509 20.2881 51.0282 19.9554 47.2878C19.7294 44.748 17.4463 42.8992 14.915 43.2062C11.1872 43.6584 8.56897 39.6267 10.4983 36.4051C11.8083 34.2175 11.048 31.3798 8.81966 30.1403C5.538 28.315 5.78959 23.5144 9.24408 22.042C11.5898 21.0423 12.6426 18.2996 11.5684 15.9871C9.98636 12.5814 13.0116 8.84552 16.6718 9.68487C19.1571 10.2548 21.6209 8.65478 22.1112 6.1525Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "strokePath",
    d: "M20.8842 5.91181C21.8062 1.20663 27.7358 -0.382271 30.8868 3.23162C32.0985 4.6214 34.2195 4.73264 35.5699 3.47714C39.0815 0.212446 44.8119 2.41258 45.2368 7.18853C45.4002 9.02505 47.0513 10.3617 48.8817 10.1397C53.6417 9.56232 56.9853 14.7108 54.5218 18.8245C53.5745 20.4063 54.1242 22.4578 55.7355 23.3541C59.9256 25.685 59.604 31.8145 55.1931 33.6945C53.4969 34.4174 52.7357 36.4014 53.5124 38.0736C55.5323 42.4222 51.6696 47.192 46.9961 46.1203C45.1991 45.7082 43.4179 46.8653 43.0632 48.6745C42.1413 53.3799 36.2116 54.9688 33.0606 51.3547C31.8489 49.9652 29.7278 49.8539 28.3775 51.1091C24.866 54.374 19.135 52.1748 18.7099 47.3989C18.5465 45.5625 16.896 44.2247 15.0657 44.4466C10.3057 45.024 6.96229 39.8764 9.42581 35.7628C10.3731 34.181 9.82327 32.1294 8.21209 31.2331C4.02179 28.9023 4.34325 22.7718 8.75423 20.8918C10.4502 20.1687 11.211 18.186 10.4342 16.5138C8.41425 12.1652 12.2777 7.39423 16.9513 8.46597C18.7485 8.87811 20.5297 7.72125 20.8842 5.91181Z",
    stroke: "#FF9900",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_badge",
    x: 0,
    y: 0,
    width: 63.9473,
    height: 62.5869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.611b63759e594fa681de9e04ad09f47f.svg";
export { ForwardRef as ReactComponent };